import { useEffect, useState } from "react";
import { LineChart as DetailsModalLineChart } from "../lineChart";

export const LineChart = ({ sensor, dataToChart }) => {
    const [minData, setMinData] = useState(0);
    const [maxData, setMaxData] = useState(0);
    const [datasets, setDatasets] = useState([]);
    const [loadingChart, setLoadingChart] = useState(true);

    useEffect(() => {

        if ("sensor1Values" in dataToChart && "sensor2Values" in dataToChart && "sensor3Values" in dataToChart && "sensor4Values" in dataToChart) {
            setDatasets([
                {
                    label: 'Temp P',
                    data: dataToChart.sensor1Values,
                    borderColor: 'rgb(0, 121, 239)',
                    backgroundColor: 'rgba(0, 121, 239, 0.5)',
                    showLine: true,
                    lineTension: 0.5,
                    borderWidth: 2,
                    pointStyle: 'rect',
                },
                {
                    label: 'Temp S',
                    data: dataToChart.sensor2Values,
                    borderColor: 'rgba(0, 179, 52)',
                    backgroundColor: 'rgba(0, 179, 52, 0.5)',
                    showLine: true,
                    lineTension: 0.5,
                    borderWidth: 2,
                    pointStyle: 'rect',
                },
                {
                    label: 'Temp M',
                    data: dataToChart.sensor4Values,
                    borderColor: 'rgba(158, 141, 8, 62)',
                    backgroundColor: 'rgba(158, 141, 8, 0.5)',
                    showLine: true,
                    lineTension: 0.5,
                    borderWidth: 2,
                    pointStyle: 'rect',
                },
                {
                    label: 'Temp E',
                    data: dataToChart.sensor3Values,
                    borderColor: 'rgba(237, 142, 35)',
                    backgroundColor: 'rgba(237, 142, 35,  0.5)',
                    showLine: true,
                    lineTension: 0.5,
                    borderWidth: 2,
                    pointStyle: 'rect',
                },
                {
                    label: "",
                    data: dataToChart.sensorMinThresholdValues,
                    borderColor: 'rgb(255, 0, 0)',
                    backgroundColor: 'rgb(255, 0, 0)',
                    borderDash: [5, 5],
                    borderWidth: 3,
                    pointStyle: 'dash',
                },
                {
                    label: "",
                    data: dataToChart.sensorMaxThresholdValues,
                    borderColor: 'rgb(255, 0, 0)',
                    backgroundColor: 'rgb(255, 0, 0)',
                    borderDash: [5, 5],
                    borderWidth: 3,
                    pointStyle: 'dash',
                },
            ]);
        }
        else if ("sensor1Values" in dataToChart && "sensor2Values" in dataToChart) {
            if (sensor === 'humidity') {
                setDatasets([
                    {
                        label: 'Umd P',
                        data: dataToChart.sensor1Values,
                        borderColor: 'rgb(0, 121, 239)',
                        backgroundColor: 'rgba(0, 121, 239, 0.5)',
                        showLine: true,
                        lineTension: 0.5,
                        borderWidth: 2,
                        pointStyle: 'rect',
                    },
                    {
                        label: 'Umd S',
                        data: dataToChart.sensor2Values,
                        borderColor: 'rgba(0, 179, 52)',
                        backgroundColor: 'rgba(0, 179, 52, 0.5)',
                        showLine: true,
                        lineTension: 0.5,
                        borderWidth: 2,
                        pointStyle: 'rect',
                    },
                    {
                        label: 'Umd M',
                        data: dataToChart.sensor3Values,
                        borderColor: 'rgba(158, 141, 8, 62)',
                        backgroundColor: 'rgba(158, 141, 8, 0.5)',
                        showLine: true,
                        lineTension: 0.5,
                        borderWidth: 2,
                        pointStyle: 'rect',
                    },
                    {
                        label: "",
                        data: dataToChart.sensorMinThresholdValues,
                        borderColor: 'rgb(255, 0, 0)',
                        backgroundColor: 'rgb(255, 0, 0)',
                        borderDash: [5, 5],
                        borderWidth: 3,
                        pointStyle: 'dash',
                    },
                    {
                        label: "",
                        data: dataToChart.sensorMaxThresholdValues,
                        borderColor: 'rgb(255, 0, 0)',
                        backgroundColor: 'rgb(255, 0, 0)',
                        borderDash: [5, 5],
                        borderWidth: 3,
                        pointStyle: 'dash',
                    },
                ]);

            } else if ("sensor1Values" in dataToChart) {
                if (sensor === 'co2') {
                    setDatasets([
                        {
                            label: 'CO2',
                            data: dataToChart.sensor1Values,
                            borderColor: 'rgb(0, 121, 239)',
                            backgroundColor: 'rgba(0, 121, 239, 0.5)',
                            showLine: true,
                            lineTension: 0.5,
                            borderWidth: 2,
                            pointStyle: 'rect',
                        },
                        {
                            label: "",
                            data: dataToChart.sensorMinThresholdValues,
                            borderColor: 'rgb(255, 0, 0)',
                            backgroundColor: 'rgba(255, 0, 0, 0.5)',
                            borderDash: [5, 5],
                            borderWidth: 3,
                            pointStyle: 'dash',
                        },
                        {
                            label: "",
                            data: dataToChart.sensorMaxThresholdValues,
                            borderColor: 'rgb(255, 0, 0)',
                            backgroundColor: 'rgba(255, 0, 0, 0.5)',
                            borderDash: [5, 5],
                            borderWidth: 3,
                            pointStyle: 'dash',
                        },
                    ]);
                } else if (sensor === 'mechnical-vibrations') {
                    setDatasets([
                        {
                            label: 'Vibração',
                            data: dataToChart.sensor1Values,
                            borderColor: 'rgb(0, 121, 239)',
                            backgroundColor: 'rgb(0, 121, 239)',
                            showLine: true,
                            lineTension: 0.5,
                            borderWidth: 2,
                            pointStyle: 'rect',
                        },
                        {
                            label: "",
                            data: dataToChart.sensorMinThresholdValues,
                            borderColor: 'rgb(255, 0, 0)',
                            backgroundColor: 'rgb(255, 0, 0)',
                            borderDash: [5, 5],
                            borderWidth: 3,
                            pointStyle: 'dash',
                        },
                        {
                            label: "",
                            data: dataToChart.sensorMaxThresholdValues,
                            borderColor: 'rgb(255, 0, 0)',
                            backgroundColor: 'rgb(255, 0, 0)',
                            borderDash: [5, 5],
                            borderWidth: 3,
                            pointStyle: 'dash',
                        },
                    ]);
                }
            }
        }

        setLoadingChart(false);

    }, [dataToChart]);

    if (!loadingChart) {
        return (
            <DetailsModalLineChart
                name={sensor}
                labels={dataToChart.labels}
                datasets={datasets}
                yMin={minData}
                yMax={maxData}
            />
        );
    }

}

